<template>
    <ul class="dropdown-menu">
        <li class="header">{{ infoMessage }}</li>
        <li>
            <ul class="menu">
                <topbar-unread-notification v-for="unreadNotification in unreadNotifications"
                                            :unread-notification="unreadNotification"
                                            :read-route-base="readRouteBase"
                                            :key="unreadNotification.id"></topbar-unread-notification>
                <li class="text-center" v-if="unreadNotifications.length == 0">
                    <a href="#">{{ _t('No new notifications') }}</a>
                </li>
            </ul>
        </li>
        <li class="footer"><a :href="viewAllRoute">{{ _t('View all') }}</a></li>
    </ul>
</template>


<script>
    import TopbarUnreadNotification from './unreadNotification.vue';

    export default {
        props: ['getRoute', 'viewAllRoute', 'baseRoute', 'markAllAsReadRoute', 'readRouteBase'],
        components: {
            'topbar-unread-notification': TopbarUnreadNotification,
        },
        data() {
            return {
                unreadNotifications: [],
                infoMessage: '',
                dropdownOpened: false,
            }
        },
        created() {
            Event.$on('notificationRead', (unreadNotificationsCount, notificationId, infoMessage) => {
                // Se c'è un notificationId specifico, rimuovi solo quella notifica
                if (notificationId) {
                    let i = this.unreadNotifications.map(item => item.id).indexOf(notificationId)
                    if (i > -1) {
                        this.unreadNotifications.splice(i, 1)
                    }
                }
                // Aggiorna il messaggio solo se infoMessage non è null
                if (infoMessage !== null) {
                    this.infoMessage = infoMessage;
                }
            });

            axios.get(this.getRoute)
                .then((res) => {
                    this.infoMessage = res.data.infoMessage;
                    this.unreadNotifications = res.data.unreadNotifications;
                    // Allinea il badge campanella al dato API (la topbar SSR può usare cache stale).
                    const n = this.unreadNotifications.length;
                    Event.$emit('notificationRead', n, null, this.infoMessage);
                });
            
            // Listen for real-time notifications via WebSocket (with fallback)
            if (window.Echo && typeof window.Echo.private === 'function' && window.Laravel && window.Laravel.user) {
                try {
                    const userId = window.Laravel.user.id;
                    window.Echo.private(`user.${userId}`)
                        .listen('.notification.new', (e) => {
                            console.log('🔔 New notification received:', e);
                            // Validate notification structure
                            if (e.notification && e.notification.id) {
                                // Add notification to the beginning of the array
                                this.unreadNotifications.unshift(e.notification);
                                // Update info message
                                this.infoMessage = `Hai ${this.unreadNotifications.length} notifiche non lette`;
                                // Emit event to update badge counter
                                Event.$emit('notificationRead', this.unreadNotifications.length, null, this.infoMessage);
                                // Show toast notification
                                if (typeof toastr !== 'undefined') {
                                    toastr.info(e.notification.title, 'Nuova notifica');
                                }
                                // Play notification sound
                                this.playNotificationSound();
                            } else {
                                console.error('❌ Notifica ricevuta ma struttura non valida:', e);
                            }
                        });
                    console.log('✅ WebSocket listener registered for notifications');
                } catch (error) {
                    console.error('❌ Failed to register WebSocket listener:', error);
                }
            } else {
                console.log('ℹ️ WebSocket not available - using polling for notifications');
            }
        },
        mounted() {
            // Listen for dropdown open event
            $(this.$el).closest('.dropdown').on('shown.bs.dropdown', () => {
                if (!this.dropdownOpened && this.unreadNotifications.length > 0) {
                    this.markAllAsRead();
                    this.dropdownOpened = true;
                }
            });
        },
        methods: {
            markAllAsRead() {
                axios.post(this.markAllAsReadRoute)
                    .then((res) => {
                        // Non svuotiamo le notifiche - devono rimanere visibili nel dropdown
                        // Aggiorniamo solo il badge a 0 ma NON il messaggio infoMessage locale
                        // Passiamo null per infoMessage per non aggiornarlo
                        Event.$emit('notificationRead', res.data.unreadNotificationsCount, null, null);
                    });
            },
            playNotificationSound() {
                try {
                    // Check if Web Audio API is available
                    const AudioContext = window.AudioContext || window.webkitAudioContext;
                    if (!AudioContext) {
                        console.warn('Web Audio API not supported');
                        return;
                    }

                    const audioContext = new AudioContext();
                    const now = audioContext.currentTime;

                    // Create a pleasant two-tone notification sound (like messenger)
                    const oscillator1 = audioContext.createOscillator();
                    const oscillator2 = audioContext.createOscillator();
                    const gainNode = audioContext.createGain();

                    // First tone (higher pitch - E note)
                    oscillator1.frequency.setValueAtTime(659.25, now);
                    oscillator1.type = 'sine';
                    oscillator1.connect(gainNode);

                    // Second tone (lower pitch - C note)
                    oscillator2.frequency.setValueAtTime(523.25, now + 0.1);
                    oscillator2.type = 'sine';
                    oscillator2.connect(gainNode);

                    // Volume envelope for smooth sound
                    gainNode.gain.setValueAtTime(0, now);
                    gainNode.gain.linearRampToValueAtTime(0.3, now + 0.01);
                    gainNode.gain.exponentialRampToValueAtTime(0.01, now + 0.3);
                    gainNode.connect(audioContext.destination);

                    // Play the tones
                    oscillator1.start(now);
                    oscillator1.stop(now + 0.15);
                    
                    oscillator2.start(now + 0.1);
                    oscillator2.stop(now + 0.3);

                    // Clean up after sound finishes
                    setTimeout(() => {
                        audioContext.close();
                    }, 500);
                } catch (error) {
                    console.error('Failed to play notification sound:', error);
                }
            }
        }
    }
</script>